@if (!customerTaskList || customerTaskList.length === 0) {
  <p>There's no task record for this customer.</p>
} @else {
  <igx-list>
    <igx-list-item isHeader="true"> Tasks </igx-list-item>
    @for (task of customerTaskList; track task) {
      <igx-list-item #item>
        <h4 igxListLineTitle>{{ task.Description }}</h4>
        <p igxListLineSubTitle>
          <i class="far fa-calendar"></i> {{ task.Date | date: "dd-MM-yyyy" }}
          <span class="badge text-bg-primary">{{ enums.taskTypeString[task.Type - 1] }}</span>
        </p>
        @if (task.DateDone != undefined) {
          <p igxListLineSubTitle>
            <strong>
              <i class="far fa-comments"></i>
              {{ task.FollowUpRemark }}
            </strong>
          </p>
        }
        <small igxListLine [style.color]="changeStatusColor(task.DateDone)">
          <strong> {{ getTaskStatusString(task.DateDone) }} | {{ task.Assignee }} </strong>
        </small>
        <div class="row">
          <div class="col">
            @if (task.DateDone == undefined && sharedService.isBranchManager() == true) {
              <button class="btn btn-warning" (click)="openNextTaskModal(task)">FOLLOW AGAIN</button>
            }
          </div>
        </div>
      </igx-list-item>
    }
  </igx-list>
}
